(function () {
  'use strict';
  if (window.__sidonieCartCountSync) return;
  window.__sidonieCartCountSync = true;

  var timer = null;

  function renderCount(count) {
    count = parseInt(count, 10) || 0;

    document.querySelectorAll('[data-sidonie-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : count;
      el.classList.toggle('is-hidden', count === 0);
    });

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function syncCount(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart sync failed');
          return response.json();
        })
        .then(function (cart) {
          renderCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);
        })
        .catch(function () {});
    }, delay || 0);
  }

  function syncAfterChange() {
    syncCount(180);
    window.setTimeout(function () { syncCount(0); }, 850);
  }

  syncCount(0);
  window.addEventListener('pageshow', function () { syncCount(0); });

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
    if (form) syncAfterChange();
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-line-change]')) {
      syncAfterChange();
    }
  }, true);

  ['cart:item-added', 'cart:updated', 'cart:change', 'cart-drawer:open'].forEach(function (eventName) {
    document.addEventListener(eventName, syncAfterChange);
  });
})();
